{
  "title": "See Invisibility",
  "source": "Player's Handbook",
  "levelAndSchool": "2nd-level divination",
  "level": 2,
  "castingTime": "1 action",
  "range": "Self",
  "components": "V, S, M (a pinch of talc and a small sprinkling of powdered silver)",
  "duration": "1 hour",
  "description": [
    "For the duration, you see invisible creatures and objects as if they were visible, and you can see into the Ethereal Plane. Ethereal creatures and objects appear ghostly and translucent."
  ],
  "spellLists": ["artificer", "bard", "sorcerer", "wizard"]
}
